import React from 'react';
import { Icon } from 'react-icons-kit'

function PreviewIcon(props) {
    return (
        <Icon
            icon={props.icon}
            size={24}
        />
    );
}
export default PreviewIcon;